import { Field } from '@lmt/unicorn-shared/app/components/common/Field';
import { useScopedTranslation } from '@lmt/unicorn-shared/app/helpers/localization/useScopedTranslation';
import React from 'react';
import { CalendarConfigurationFormComponentProps } from '@lmt/unicorn-shared/app/components/calendar/configuration/common/types';
import { ToggleButton } from '@lmt/unicorn-shared/app/components/common/ui-kit/ToggleButton';

export const CalendarPatientsSettings: React.FC<
  CalendarConfigurationFormComponentProps
> = (props) => {
  const i18nCalendar = useScopedTranslation('calendar_configuration.patients');
  const { register } = props.formMethods;

  return (
    <>
      <ToggleButton
        {...register('isShowingPatients')}
        title={i18nCalendar.t('show_patients')}
      />
      <Field title={''}>
        <ToggleButton
          {...register('isShowingWaitingList')}
          title={i18nCalendar.t('show_waiting_list')}
        />
      </Field>
    </>
  );
};
